export default __webpack_public_path__ + "static/media/mps-2025-class-10-result.32390fe5.jpg";